import {useAuth} from '@/hooks/useAuth'
import {SecondaryButton} from '@/shared-components/Button'
import {useIntl} from 'react-intl'

export const Logout = () => {
  const {formatMessage} = useIntl()
  const {instance} = useAuth()

  const onClickLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: `${window.location.origin}/login`,
    })
  }

  return (
    <div className="flex justify-end">
      <SecondaryButton data-testid="btn-logout" onClick={onClickLogout}>
        {formatMessage({id: 'LOGOUT.LOGOUT_BUTTON'})}
      </SecondaryButton>
    </div>
  )
}
